import { key, notify } from '@databases/ping-registry';
import { getService } from '@databases/service-container';
import { createCellEditingEffect } from '@databases/value/cell-edit-effect';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export function createCellEditingEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.CELL_EDITING_EFFECT,
    type: 'effect',
    isEnabled: (ctx) => ctx.permissions.canEditContent,
    factory: () =>
      createCellEditingEffect({
        selectionsApi: getService('SelectionsApi'),
        notifyCellEditing: (
          entryId: string,
          fieldId: string,
          editing: boolean,
          context: 'table' | 'panel'
        ): void => {
          notify(key('cell', { entryId, fieldId }), 'editing', {
            active: editing,
            context,
          });
        },
      }),
  };
}
